import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseExchangeCodeForSessionRepository } from '@/modules/auth/infra/repositories'
import type { ExchangeCodeForSession } from '@/modules/auth/use-cases'

export function makeExchangeCodeForSession(): ExchangeCodeForSession {
  return new SupabaseExchangeCodeForSessionRepository(makeSupabaseClient()).execute
}
